import {
  Factory,
  ProjectActions,
  type SectionItem,
} from '@octopus-do/octopus-project-core'
import { call, put } from 'redux-saga/effects'

import { BASE_COLOR_CLOUDY } from '@/constants/constants'
import { DEFAULT_SECTION_TITLE } from '@/utils/xml'
import { waitForDependency } from '../saga/waits'

export const createSectionItem = ({
  id,
  title,
  tabId,
  order,
}: {
  id: string
  title: string
  tabId: string
  order: number
}): SectionItem =>
  Factory.section({
    id,
    title: title || DEFAULT_SECTION_TITLE,
    tabId,
    colorId: BASE_COLOR_CLOUDY.id,
    order,
    textSize: 's',
  })

export function* addSection({
  section,
  index,
  tabId,
}: {
  section: SectionItem
  index: number
  tabId: string
}): Generator<any, void, any> {
  yield put(
    ProjectActions.sections.add({
      items: [section],
      index,
      parents: [tabId],
    })
  )

  yield call(waitForDependency, {
    id: section.id,
    type: 'section',
  })
}
